import { IOrganizationBankAccountState, IStateMetadata, IOrganizationLegalEntityState } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import { actionCreators as organizationActionCreators } from '../../actions/organizations'
import * as constants from '../../constants'
import { IOrganizationActions } from '../../actions/organizations'

const initProviderState: IOrganizationBankAccountState = {
  items: {},
  metadata: {
    fetching: false,
    fetchingError: '',
    fetchingSuccess: '',
    processing: false,
    processingError: '',
    processingSuccess: ''
  }
}

export function organizationsBankAccounts(
  state: IOrganizationBankAccountState,
  action: any
): IOrganizationBankAccountState {
  if (typeof state === 'undefined') {
    return initProviderState
  }
  const metadata = {
    fetching: false,
    fetchingError: '',
    fetchingSuccess: '',
    processing: false,
    processingError: '',
    processingSuccess: ''
  }
  switch (action.type) {
    case constants.CREATE_ORGANIZATION_BANK_ACCOUNT_REQUEST:
      metadata.processing = true
      return Object.assign({}, state, { metadata })
    case constants.CREATE_ORGANIZATION_BANK_ACCOUNT_SUCCESS:
      const organizationBankAccount = action.payload
      const items = Object.assign({}, state.items, organizationBankAccount)
      metadata.processing = false
      metadata.processingSuccess = UIMessages.organization.bankAccount.successfullyUpdated
      return Object.assign({}, state, { items, metadata })
    case constants.CREATE_ORGANIZATION_BANK_ACCOUNT_FAILURE:
      metadata.processing = false
      metadata.processingError = action.payload
      return Object.assign({}, state, { metadata })
    case constants.REMOVE_ORGANIZATION_BANK_ACCOUNT_REQUEST:
      metadata.processing = true
      return Object.assign({}, state, { metadata })
    case constants.REMOVE_ORGANIZATION_BANK_ACCOUNT_SUCCESS: {
      const organizationBankAccountId = action.payload
      const items = Object.assign({}, state.items)
      delete items[organizationBankAccountId]
      metadata.processing = false
      metadata.processingSuccess = UIMessages.organization.bankAccount.successfullyRemoved
      return Object.assign({}, state, { items, metadata })
    }
    case constants.REMOVE_ORGANIZATION_BANK_ACCOUNT_FAILURE:
      metadata.processing = false
      metadata.processingError = action.payload
      return Object.assign({}, state, { metadata })
    case constants.UPDATE_ORGANIZATION_BANK_ACCOUNT_REQUEST:
      metadata.processing = true
      return Object.assign({}, state, { metadata })
    case constants.UPDATE_ORGANIZATION_BANK_ACCOUNT_SUCCESS: {
      const organizationBankAccountList = action.payload
      const items = Object.assign({}, state.items, organizationBankAccountList)
      metadata.processing = false
      metadata.processingSuccess = UIMessages.organization.bankAccount.successfullyUpdated
      return Object.assign({}, state, { items, metadata })
    }
    case constants.UPDATE_ORGANIZATION_BANK_ACCOUNT_FAILURE:
      metadata.processing = false
      metadata.processingError = action.payload
      return Object.assign({}, state, { metadata })
    case constants.GET_ORGANIZATION_LEGAL_ENTITY_REQUEST:
      metadata.processing = true
      return Object.assign({}, state, { metadata })
    case constants.GET_ORGANIZATION_LEGAL_ENTITY_SUCCESS:
      metadata.processing = false
      metadata.processingSuccess = UIMessages.organization.bankAccount.successfullyRemoved
      return Object.assign({}, state, { items: action.payload.bankAccounts, metadata })
    case constants.GET_ORGANIZATION_LEGAL_ENTITY_FAILURE:
      metadata.processing = false
      metadata.processingError = action.payload
      return Object.assign({}, state, { metadata })
  }
  return state
}



// WEBPACK FOOTER //
// ./src/state/reducers/organizations/bank-account.ts